<template>
  <j-modal :title="title" v-dragModal :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-divider orientation="left">{{ $t('报修信息') }}</a-divider>
              <detail-list>
                <detail-list-item :term="$t('报修人名称')">{{model.repairName}}</detail-list-item>
                <detail-list-item :term="$t('报修人电话')">{{model.repairPhone}}</detail-list-item>
                <detail-list-item :term="$t('报修户地址')">{{model.repairAddress}}</detail-list-item>
                <detail-list-item :term="$t('报修时间')">{{model.repairTime}}</detail-list-item>
                <detail-list-item :term="$t('报修描述')" :itemCol="1">{{model.repairDescription}}</detail-list-item>
              </detail-list>
              <div style="color: #999;">
                {{ $t('报修图片:') }}
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="picture" :disabled="true"></j-image-upload>
              </div>
            </a-col>
          </a-row>
          <template>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-divider orientation="left">{{ $t('处理信息') }}</a-divider>
                <a-form-model-item :label="$t('是否开启工单')" prop="ifNeedCreateTickets">
                  <a-radio-group v-model="model.ifNeedCreateTickets">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" v-if="model.ifNeedCreateTickets == 0">
              <a-col :span="24">
                <a-form-model-item :label="$t('回复内容')" prop="response">
                  <a-textarea v-model="model.response" :placeholder="$t('请输入回复内容')" :rows="4" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <template v-if="model.ifNeedCreateTickets == 1">
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单类型')">
                    <a-select v-model="model.ticketsType" :placeholder="$t('请选择工单类型')" :disabled="true">
                      <a-select-option :value="0">{{ $t('换表') }}</a-select-option>
                      <a-select-option :value="1">{{ $t('工程报装') }}</a-select-option>
                      <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单联系人')" prop="repairName">
                    <!-- <el-input type="text" size="small" v-model.trim="model.ticketsContact" placeholder="请输入工单联系人" maxlength="20" show-word-limit /> -->
                    <a-input v-model="model.repairName" :placeholder="$t('请输入工单联系人')" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('联系电话')" prop="repairPhone">
                    <!-- <a-input v-model="model.ticketsContactPhone" placeholder="请输入联系电话"></a-input> -->
                    <a-input v-model="model.repairPhone" :placeholder="$t('请输入联系电话')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                    <j-dict-select-tag v-model="model.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')" dictCode="ticketsEmergency" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('地理信息')" prop="ticketsLocation">
                    <!-- <a-input v-model="model.ticketsLocation" placeholder="请输入工单位置"></a-input> -->
                    <a-input v-model="model.repairAddress" :placeholder="$t('请输入工单位置')"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('预约时间')" prop="ticketsDeadline">
                    <!-- <a-date-picker show-time v-model="model.ticketsDeadline" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" /> -->
                    <a-date-picker show-time v-model="model.dealTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
import { mode } from 'mathjs'
  export default {
    name: 'assignModal',
    components: {
      DetailList,
      DetailListItem,
      JImageUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {
          tickets:{
            ticketsType: 2
          }
        },
        url: {
          queryById: "/jeecg-engineering/wechatapply/wechatMeterRepair/queryById",
          edit: "/jeecg-engineering/wechatapply/wechatMeterRepair/edit",
        },
        picture:''
      }
    },
    computed: {
      validatorRules() {
        return {
          ifNeedCreateTickets: [{
            required: true,
            message: this.$t('请选择是否开启工单'),
            trigger: 'change'
          }],
          response: [{
            required: true,
            message: this.$t('请输入回复内容'),
            trigger: 'blur'
          }],
          repairName: [{required:true,message:this.$t('请输入工单联系人'),trigger:'blur'}],
          repairPhone: [{required:true,message:this.$t('请输入联系电话'),trigger:'blur'},{pattern: PhoneNumberPattern,message: this.$t('请输入正确的手机号码')}],
          ticketsEmergency: [{required:true,message:this.$t('请选择紧急程度'),trigger:'change'}],
        }
      },
    },
    methods: {
      init(row){
        this.title = this.$t('处理');
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.model.ticketsType = 2;
        this.$nextTick(()=>{
          // var arr = JSON.parse(this.model.repairPicture);
          // this.$set(this,'picture',arr.join(','));
          this.$set(this,'picture',this.model.repairPicture);
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            // this.model.tickets = {
            //   ticketsType: this.model.ticketsType,
            //   ticketsContact: this.model.ticketsContact,
            //   ticketsContactPhone: this.model.ticketsContactPhone,
            //   ticketsEmergency: this.model.ticketsEmergency,
            //   ticketsLocation: this.model.ticketsLocation,
            //   ticketsDeadline: this.model.ticketsDeadline
            // }
            // let repairPicture = JSON.parse(this.model.repairPicture);
            let params = {
              ifNeedCreateTickets:  that.model.ifNeedCreateTickets,
              ticketsFrom: "UserOA",
              sourceType: 0,
              ticketsType: 2,
              ticketsEmergency: that.model.ticketsEmergency,
              dealTime: that.model.dealTime,
              // repairPicture: repairPicture.join(','),
              repairPicture: that.model.repairPicture,
              ticketsForeignId: that.model.id,
              userId: that.model.userId,
              response: that.model.response,
              ticketsRepairReq: {
                repairName: that.model.repairName,
                repairPhone: that.model.repairPhone,
                repairAddress: that.model.repairAddress,
                repairDescription: that.model.repairDescription
              }
            }
            postAction(this.url.edit, params).then((res) => {
              if (res.success) {
                that.$message.success(res.message || that.$t('处理成功！'));
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      handleCancel() {
        this.close()
      },
    }
  }
</script>
<style scoped lang="less">
  /deep/.ant-form-item-label > label{
    color: #999;
  }
</style>